import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-tanker',
  templateUrl: './tanker.component.html',
  styleUrls: ['./tanker.component.css'],
})
export class TankerComponent {
  @Input() totalVolume: string = '?';
  @Input() compartments: string[] = ['??'];
  // Si añades o quitas elementos aquí, el CSS se ajusta automáticamente
}
